import React from 'react';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles =  makeStyles(theme =>({
  root:{
    padding:theme.spacing(3,2),
    height:'100%',
  }
}));
export default function About() {
  const classes = useStyles()
  return (

<Paper className={classes.root}>
  <div className="About">
  <a href="www.google.com" target="_blank">Resume</a>
    <h2>Panchajanya Mysarla</h2>
    <h3>Work</h3>

    <h4>J.B Hunt Transport Inc</h4>
    <h6>April 2018 - Till Date</h6>
    <ul>
      <li>Perform Lead role for multiple teams in developing and delivering the best Angular App.</li>
      <li>Assist in Design and Implementation process of new features of the App.</li>
      <li>Architected the Angular App using all the state of the art features like Lazy Loading, Modularization, Routing, Reusable Components, Single Responsibility.</li>
      <li>
        Developed Undo & Redo features on a complex Reactive Forms using State Management NGRX.</li>
      <li>Developed features in an API Architecture way so other apps can interact.</li>
      <li>Prepare and dispense work assignments, provide guidance, and/or review the work of other team members.</li>
      <li>Mentor Fellow team members and an entire Intern Squad in developing and delivering quality Angular App.</li>
      <li>Write backend Web Services code whenever needed.</li>
      <li>Reviewing/taking the architecture decisions in the early stage of development which helps the company’s effort and budget in long run.</li>
      <li>Collaborate with QA team to define test cases, metrics, and resolve questions about test results</li>
    </ul>

    <h4>Fitch Ratings</h4>
    <h6>April 2016 - April 2018</h6>
    <ul>
      <li>Developed Angular Components</li>
      <li>Wrote Unit Tests using jasmine, karma</li>
      <li>Implemented Custom MAIL API to improve mail alerts
      </li>
      <li>Fixed data processing issue for email alerts which reduced daily errors by 75% from 2000 to 500.</li>
      <li>Designed and Updated database tables to support new TREPP feed in Calls_Datafeed.</li>
      <li>Investigated USPF backend process and fixed a major bug solving the data inconsistency which existed from a very long time.</li>
      <li>Wrote Sql queries</li>
    </ul>

    <h4>Smart Works</h4>
    <h6>September 2015 - March 2016</h6>
    <ul>
      <li>Developed and Implemented Rest Services using Spring MVC</li>
      <li>Implemented various core java concepts like Collections</li>
    </ul>

    <h4>Infosys India</h4>
    <h6>January 2014 - June 2014</h6>
    <ul>
      <li>Learn Java and wrote java code</li>
    </ul>

    <h3>Education</h3>
    <h4> Northen Illinois University, Dekalb, IL</h4>
    <ul>
      <li> Master of Science</li>
      <li>
        Major: Computer Science
      </li>
      <li>Grad -> December 2015</li>
    </ul>

    <h4> JNTUH, Hyderabad, India
    </h4>
    <ul>
      <li> Bachelor of Technology</li>
      <li>
        Major: Information Technology
      </li>
      <li> Grad -> June 2014</li>
    </ul>

  </div>


</Paper>

)}
